module.exports = __webpack_public_path__ + "static/img/01.0b1eac1e.png";